
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"32","viewBox":"0 0 32 32","width":"32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.219 2.161a.646.646 0 00-.31.078L.357 10.583a.668.668 0 00-.357.565c0 .119.03.236.091.339s.149.185.252.242l5.258 2.951v6.724c0 .115.025.226.078.328.105.185 2.741 4.628 10.162 4.628h.003c2.784 0 4.935-.625 6.544-1.414l-.919 4.089a.613.613 0 00-.003.292.641.641 0 00.356.448.67.67 0 00.292.065h1.898a.678.678 0 00.554-.25.64.64 0 00.117-.555l-.907-4.039c.001-.016.01-.031.01-.047v-.81c1.682-1.127 2.452-2.279 2.518-2.378a.582.582 0 00.12-.357v-6.648l5.245-3.026a.682.682 0 00.328-.58.666.666 0 00-.341-.565l-15.13-8.344a.646.646 0 00-.31-.078zm-.01 1.409l13.786 7.607-6.591 3.781-5.766-3.75c.005-.051.03-.099.035-.151a1.473 1.473 0 00-.887-1.364 1.467 1.467 0 00-2.026 1.021 1.478 1.478 0 001.373 1.807c.197.005.394-.028.578-.099.067-.026.117-.08.18-.115l5.203 3.401-5.883 3.375-14.18-7.906zM6.917 15.656l8.961 4.797a.606.606 0 00.31.086c.005 0 .015-.005.02-.005a.72.72 0 00.331-.078l1.289-.742 4.589-2.557v6.331c-1.487.853-3.629 1.607-6.578 1.607-5.997 0-8.447-3.124-8.922-3.823zm18.149.026v5.562c-.176.24-.607.74-1.279 1.294v-6.146z"}})])
          )
        }
      }
    